import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {

    return (<>
        <header className="header header-light header-topbar" id="navbar-spy">
            {/* <!-- Start .top-bar--> */}
            <div className="top-bar">
                <div className="block-left">
                    {/* <div className="top-contact">
                        <div className="contact-infos"><i className="fas fa-phone-alt"></i>
                            <div className="contact-body"> <a href="tel:+55-654-541-17" style={{ fontWeight: '1000' }}>Phone: (+91) 9454311900</a></div>
                        </div>
                        <div className="contact-infos"><i className="fas fa-envelope"></i>
                            <div className="contact-body"> <a href="#" style={{ fontWeight: '1000' }}>Email: <span className="__cf_email__" data-cfemail="6a390b040f180b2a5d051805050c44090507">info@octopussindia.com</span></a></div>
                        </div>
                        <div className="contact-infos"><i className="fas fa-clock"></i>
                            <div className="contact-body">
                                <p style={{ fontWeight: '1000' }}>Hours: Mon-Sat: 9AM – 8PM					</p>
                            </div>
                        </div>
                    </div> */}
                    <div className="top-contact">
                        {/* Desktop only */}
                        <div className="contact-infos d-none d-lg-flex">
                            <i className="fas fa-phone-alt"></i>
                            <div className="contact-body">
                                <a href="tel:+55-654-541-17" style={{ fontWeight: '1000', fontSize:'15px' }}>
                                    Phone: (+91) 9454311900
                                </a>
                            </div>
                        </div>

                        {/* Email - shows on all */}
                        <div className="contact-infos flex-grow-1 text-center">
                            <i className="fas fa-envelope"></i>
                            <div className="contact-body">
                                <a href="mailto:info@octopussindia.com" style={{ fontWeight: '1000', fontSize:'15px' }}>
                                    Email: info@octopussindia.com
                                </a>
                            </div>
                        </div>

                        {/* Hours - right side */}
                        <div className="contact-infos text-end">
                            <i className="fas fa-clock"></i>
                            <div className="contact-body">
                                <p style={{ fontWeight: '1000', fontSize:'15px' }}>Mon-Sat: 9AM – 8PM</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="block-right">

                    {/* <div className="top-bar-links-wrapper"><a className="top-bar-link" href="blog-grid-fullwidth.html">news & media</a><a className="top-bar-link" href="page-careers.html">careers</a><a className="top-bar-link" href="page-faqs.html">FAQs</a></div> */}
                    {/* <!-- Start .module-social--> */}
                    <div className="module module-social"><a className="share-facebook" href="#"><i className="fab fa-facebook-f"> </i></a><a className="share-instagram" href="#"><i className="fab fa-instagram"></i></a><a className="share-twitter" href="#"><i className="fab fa-twitter"></i></a></div>

                </div>
            </div>
            {/* <!-- End .top-bar--> */}
            <nav className="navbar navbar-expand-xl navbar-sticky" id="primary-menu"><Link className="navbar-brand" to="/"><img className="logo logo-dark" src="assets/images/logo/site-logo.jpg" alt="Medisch Logo" /><img className="logo logo-mobile" src="assets/images/logo/site-logo.jpg" alt="Medisch Logo" /></Link>
                <div className="module-holder module-holder-phone">
                    {/* <div className="module module-search">
                        <div className="module-icon module-icon-search"><i className="icon-search"></i><span>search</span></div>
                    </div> */}
                    {/* <!-- End .module-search-->
                    <!-- Start .module-language--> */}
                    {/* <div className="module module-language">
                        <div className="selected"><img src="assets/images/module-language/en.png" alt="alt" /><span>english</span><i className="fas fa-chevron-down"></i></div>
                        <div className="lang-list">
                            <ul>
                                <li> <img src="assets/images/module-language/en.png" alt="alt" /><a href="#">english</a></li>
                                <li> <img src="assets/images/module-language/ar.png" alt="alt" /><a href="#">arabic</a></li>
                            </ul>
                        </div>
                    </div> */}
                    <button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent" aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation"><span className="navbar-toggler-icon"></span></button>
                </div>
                <div className="collapse navbar-collapse" id="navbarContent">
                    <ul className="navbar-nav mx-auto">
                        <li className="nav-item" id="contact" data-hover=""><Link to="/"><span>HOME</span></Link></li>
                        <li className="nav-item" id="contact" data-hover=""><Link to="/About-us"><span>ABOUT US</span></Link></li>
                        <li className="nav-item has-dropdown" data-hover=""><a className="dropdown-toggle" href="#" data-toggle="dropdown"><span>OUR SERVICES</span></a>
                            <ul className="dropdown-menu" style={{ width: '310px' }}>
                                <li className="nav-item"><Link to="/Octopuss-Jobs"><span style={{ textTransform: 'uppercase' }}>Octopuss Jobs</span></Link></li>
                                <li className="nav-item"><Link to="/Octopuss-Technologies"><span style={{ textTransform: 'uppercase' }}>Octopuss Technologies</span></Link></li>
                                <li className="nav-item"><Link to="/Octopuss-Events"><span style={{ textTransform: 'uppercase' }}>Octopuss Events</span></Link></li>
                                <li className="nav-item"><Link to="/Octopuss-Retails"><span style={{ textTransform: 'uppercase' }}>Octopuss Retails</span></Link></li>
                                <li className="nav-item"><Link to="/Octopuss-Infratructure"><span style={{ textTransform: 'uppercase' }}>Octopuss Infratructure</span></Link></li>
                                <li className="nav-item"><Link to="/Octopuss-Security"><span style={{ textTransform: 'uppercase' }}>Octopuss Security</span></Link></li>
                                <li className="nav-item"><Link to="/Facility-Management-System"><span style={{ textTransform: 'uppercase' }}>Facility Management System</span></Link></li>
                            </ul>
                        </li>
                        <li className="nav-item" id="contact" data-hover=""><Link to="/Our-Clients"><span>OUR CLIENTS</span></Link></li>
                        <li className="nav-item" id="contact" data-hover=""><Link to="/Gallery"><span>GALLERY</span></Link></li>
                        <li className="nav-item" id="contact" data-hover=""><Link to="/Contact-Us"><span>CONTACT US</span></Link></li>
                    </ul>
                    <div className="module-holder">
                        {/* <div className="module module-search">
                            <div className="module-icon module-icon-search"><i className="icon-search"></i><span>search</span></div>
                        </div> */}
                        {/* <!-- End .module-search-->
                        <!-- Start .module-contact--> */}
                        <div className="module-contact"><a className="btn btn--secondary" href="#">Made2klean</a></div>
                    </div>
                    {/* <!--  End .module-holder--> */}
                </div>
                {/* <!--  End .navbar-collapse--> */}
            </nav>
            {/* <!--  End .container--> */}
        </header>
    </>)
}
export default Header;